// The latest approval is the most recently RECORDED one (highest id), which is
// what the customer last agreed to, whatever time they said it.
export const latestApproval = (authorizations) =>
  (authorizations || []).reduce((latest, a) => (!latest || a.id > latest.id ? a : latest), null);

// toFixed(2) first, the same rounding the approval form pre-fills with: a
// total of 225.225 rounds DOWN in toFixed (binary 225.22499…) but UP in a bare
// Math.round(x * 100), which flagged a fresh approval as $0.01 short.
const cents = (n) => Math.round(Number(Number(n || 0).toFixed(2)) * 100);

// How far the current total is above the latest approval, to the cent. No
// approval means nothing has been approved yet, which is not "over".
export const amountOverApproved = (total, authorizations) => {
  const latest = latestApproval(authorizations);
  if (!latest) return 0;
  const over = cents(total) - cents(latest.authorized_amount);
  return over > 0 ? over / 100 : 0;
};

export const METHOD_LABELS = {
  signed: 'Signed',
  phone: 'Phone',
  in_person: 'In person',
  online: 'Approved by customer online',
};
